import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NewsService} from 'src/app/modules/news/news.service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Component, computed, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {AuthenticationService} from 'kkm-library';
import {DeviceScaleService} from 'kkm-library';
import {NgClass} from '@angular/common';

import {NewsCardLargeComponent} from '../news-card-large/news-card-large.component';

@Component({
    templateUrl: './news-page.component.html',
    styleUrls: ['./news-page.component.scss'],
    imports: [
        NewsCardLargeComponent,
        MatProgressSpinnerModule,
        MatCardModule,
        MatButtonModule,
        MatTooltipModule,
        NgClass,
        MatIconModule,
    ],
})
export class NewsPageComponent {
    public authService = inject(AuthenticationService);
    private newsService = inject(NewsService);
    public deviceScaleService = inject(DeviceScaleService);

    newsListe = computed(() => this.newsService.newsListe());
    isLoading = computed(() => this.newsService.isLoading());
    isLoggedIn = computed(() => this.authService.loginStatus());

    public newEntry = false;

    public reloadEntrys(): void {
        this.newEntry = false;
    }
}
